// src/auth/useLogout.ts
import keycloak from "@config/keycloak";
import { useAuthStore } from "@persisted-state/auth/auth.store";
import { useQueryClient } from "@tanstack/react-query";

export function useLogout() {
  const qc = useQueryClient();
  const { user } = useAuthStore();
  const isUaePassUser = Boolean(user?.uaeUuid);

  const clearLocalState = () => {
    const store = useAuthStore.getState();
    store.clearUser();
    store.clearAuth();

    qc.clear();
    localStorage.clear();
  };

  const logout = async () => {
    const ts = Date.now();
    const redirectUri = isUaePassUser
      ? `${window.location.origin}/logged-out?t=${ts}&uae=true`
      : `${window.location.origin}/logged-out?t=${ts}`;

    try {
      clearLocalState();
      await keycloak.logout({ redirectUri });
    } catch (err) {
      console.error("[Logout] Keycloak logout failed:", err);
      window.location.href = redirectUri;
    }
  };

  return { logout };
}
